let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bIiQl")).then(() => parcelRequire('21h9s'));